import React from "react";
const PunctualityNavbar = ({ activePage, setActivePage }) => {
  const pageName = ["Overview", "Summary", "Punctuality performance"];
  return (
    <div className="newUiBody">
      {pageName?.map((page, key) => {
        return (
          <button
            key={key}
            className={` ms-1 btn btn-sm btn-outline-dark Subject ${
              activePage === page && "active"
            }`}
            onClick={() => {
              setActivePage(page);
            }}
          >
            {page}
          </button>
        );
      })}
    </div>
  );
};
export default PunctualityNavbar;
